import { axiosGet, axiosPost } from "../../react_axios/Axios";
import {
  VENDOR_ADD_ACTION_TYPE,
  VENDOR_DELETE_ACTION_TYPE,
  VENDOR_DETAIL_ACTION_TYPE,
  VENDOR_LIST_ACTION_TYPE,
  headers, vendorAddUrl, vendorDeleteUrl, vendorDetailUrl, vendorListUrl,
} from "../../utils/constants";

export const vendor_list_action =
  (
   CompanyName
  ) =>
  async (dispatch) => {
    try {
      const mapdata = {     userId: sessionStorage.getItem("userId"),
      CompanyName:CompanyName?CompanyName:null
      };
      const params = {
        userId: mapdata.userId === "" ? null : mapdata.userId,
        CompanyName:mapdata.CompanyName===""?null:mapdata.CompanyName
       
      };
      console.log("Vendor List mapdata...", mapdata);
      const res = await axiosGet(vendorListUrl, params,headers);
      console.log("Vendor List", res);
      dispatch({
        type: VENDOR_LIST_ACTION_TYPE,
        payload: res,
      });
      return res; // No need to wrap in Promise.resolve()
    } catch (err) {
      return Promise.reject(err);
    }
  };

export const vendor_detail_action = (VendorID) => async (dispatch) => {
  try {
    const params = {
      userId: sessionStorage.getItem("userId"),
      VendorID: VendorID?VendorID:sessionStorage.getItem("VendorID")?sessionStorage.getItem("VendorID"):null,
    };
    console.log("Vendor detail mapdata...", params);
    const res = await axiosGet(vendorDetailUrl, params,headers);
    console.log("detailsVendor", res);
    dispatch({
      type: VENDOR_DETAIL_ACTION_TYPE,
      payload: res,
    });
    return res; // No need to wrap in Promise.resolve()
  } catch (err) {
    return Promise.reject(err);
  }
};

export const vendor_add_action =
  (
    VendorID,
    firstName,
    lastName,confPassword,
    designation,
    companyName,
    addressLine1,
    addressLine2,
    cityId,
    stateId,
    countryId,
    pincode,
    Mobile1,
    Mobile2,
    TelephoneNumber,
    primaryEmailID,
    secondaryEmailID,
    website,
    registrationNumber,
    PANCardNo,
    NameonPANCard,
    GSTNo,
    TANNumber,
    UINNumber,
    accountName,
    accountNo,
    accountType,
    bankName,
    branchName,
    IFSCCode,serviceSelectList,servicePackageList,packageImageList,materialList
  ) =>
  async (dispatch) => {
    try {
      const mapdata = {
        userId: parseInt(sessionStorage.getItem("userId")),
        VendorID: VendorID != "" ? VendorID : null,
        FirstName: firstName != "" ? firstName : null,
        LastName: lastName != "" ? lastName : null,
        Password: confPassword != "" ? confPassword : null,
        Designation: designation != "" ? designation : null,
        CompanyName: companyName != "" ? companyName : null,
        AddressLine1: addressLine1 != "" ? addressLine1 : null,
        AddressLine2: addressLine2 != "" ? addressLine2 : null,
        CityID: cityId != "" ? cityId : null,
        StateID: stateId != "" ? stateId : null,
        Countryid: countryId != "" ? countryId : null,
        Pincode: pincode != "" ? pincode : null,
        Mobile1: Mobile1 != "" ? Mobile1 : null,
        Mobile2: Mobile2 != "" ? Mobile2 : null,
        Telephone: TelephoneNumber != "" ? TelephoneNumber : null,
        PrimaryEmailID: primaryEmailID != "" ? primaryEmailID : null,
        SecondaryEmailID: secondaryEmailID != "" ? secondaryEmailID : null,
        Website: website != "" ? website : null,
        CompanyRegistrationNo:
          registrationNumber != "" ? registrationNumber : null,
        PanNo: PANCardNo != "" ? PANCardNo : null,
        NameOnPanCard: NameonPANCard != "" ? NameonPANCard : null,
        GSTNo: GSTNo != "" ? GSTNo : null,
        TanNo: TANNumber != "" ? TANNumber : null,
        UINNo: UINNumber != "" ? UINNumber : null,
        AccountName: accountName != "" ? accountName : null,
        AccountNo: accountNo != "" ? accountNo : null,
        AccountType: accountType != "" ? accountType : null,
        BankName: bankName != "" ? bankName : null,
        BranchName: branchName != "" ? branchName : null,
        IFSCCode: IFSCCode != "" ? IFSCCode : null,
        serviceSelectList:serviceSelectList,
        servicePackageList:servicePackageList,
        packageImageList:packageImageList,
        materialList:materialList

      };
      console.log("Vendor add mapdata...", mapdata);

      const res = await axiosPost(vendorAddUrl, mapdata, headers);
      dispatch({
        type: VENDOR_ADD_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  };
export const vendor_delete_action = (VendorID) => async (dispatch) => {
  try {
    const mapdata = {       userId: parseInt(sessionStorage.getItem("userId")),
      VendorID: VendorID,
    };

    const res = await axiosGet(vendorDeleteUrl, mapdata,headers);
    dispatch({
      type: VENDOR_DELETE_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (err) {
    return Promise.reject(err);
  }
};
